// app/javascript/bundles/company/document_defaults/page_library/selection_toolbar.tsx
import React from 'react';

import { faFolderMinus, faFolderPlus, faTrash } from '@fortawesome/pro-regular-svg-icons';

import { Button } from 'components/ui/button';
import { pluralize } from 'helpers/formatters/string_formats';

interface Props {
  count: number;
  onAdd: () => void;
  onRemove: () => void;
  onDelete: () => void;
  onClear: () => void;
}

export default function SelectionToolbar({ count, onAdd, onRemove, onDelete, onClear }: Props) {
  if (count === 0) return null;

  return (
    <div className="d-flex align-items-center gap-2 mb-3">
      <span className="fw-semibold me-2">{pluralize(count, 'page')} selected</span>
      <Button icon={faFolderPlus} size="sm" variant="secondary" onClick={onAdd}>Add to documents</Button>
      <Button icon={faFolderMinus} size="sm" variant="secondary" onClick={onRemove}>Remove from documents</Button>
      <Button icon={faTrash} size="sm" variant="destructive" onClick={onDelete}>Delete</Button>
      <Button size="sm" variant="ghost" onClick={onClear}>Clear selection</Button>
    </div>
  );
}
